export default "__VITE_ASSET__C6ch$wgM__"